import { useState } from 'react';
import RightWrapper from '../../Components/CommonComponents/ComponentWrapper';
import DataTable from '../../Components/UI/DataTable';
import { useClientTable } from '../../Components/CommonComponents/useTableData';

const headers = [
  { label: 'User Name', key: 'name' },
  { label: 'Email Address', key: 'email' },
  { label: 'User Role', key: 'role' },
];

const USERS = [
  { name: 'John Doe', email: 'john@example.com', role: 'Admin' },
  { name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
  { name: 'John Doe', email: 'john@example.com', role: 'Admin' },
  { name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
  { name: 'John Doe', email: 'john@example.com', role: 'Admin' },
  { name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
  { name: 'John Doe', email: 'john@example.com', role: 'Admin' },
  { name: 'Jane Smith', email: 'jane@example.com', role: 'User' },
  { name: 'John Doe', email: 'john@example.com', role: 'Admin' },
];

const Users = () => {
  const [role, setRole] = useState('');

  const table = useClientTable(
    role ? USERS.filter((user) => user.role === role) : USERS,
    { searchKeys: ['name', 'email', 'role'], initialQuery: { limit: 5 } }
  );

  const filters = [
    {
      key: 'role',
      label: 'All Roles',
      value: role,
      options: [
        { label: 'Admin', value: 'Admin' },
        { label: 'User', value: 'User' },
        { label: 'Editor', value: 'Editor' },
      ],
    },
  ];

  return (
    <RightWrapper>
      <div className="userpanel p-4 md:p-6">
        <DataTable
          title="Users"
          headers={headers}
          data={table.rows}
          total={table.total}
          page={table.page}
          totalPages={table.totalPages}
          rowsPerPage={table.rowsPerPage}
          onPageChange={table.setPage}
          onRowsPerPageChange={table.setLimit}
          onSearch={table.setSearch}
          searchValue={table.query.search}
          filters={filters}
          onFilter={(key, value) => key === 'role' && setRole(value)}
          rowsPerPageOptions={[5, 10, 25, 50]}
          emptyMessage="No users found."
        />
      </div>
    </RightWrapper>
  );
};

export default Users;
